enum Domain {
  AGENCY = 'agency-shipment',
  BILLING = 'billing',
  SINGLE_SHIPMENT = 'single-shipment',
  REVERSE_SHIPMENT = 'reverse-shipment',
  POINTS = 'points',
  LANDING_PAGE = 'landing-page',
  CONFIGURATION_CARRIER = 'configurations/carrier',
  DASHBOARD = 'dashboard',
  BALANCE = 'balance',
  SAVE_ON_SHIPPING = 'save-on-shipping'
}

export default Domain;
